import moment from 'moment'
import momentShortFormat from 'moment-shortformat'
import './locale'

// Formatting

export const relativeDate = dateString => {
  return moment(dateString).fromNow()
}

export const relativeShort = dateString => {
  return momentShortFormat(dateString).short(true)
}

export const absoluteDate = dateString => {
  return moment(dateString).format('l')
}

export const universalDate = dateString => {
  return moment(dateString).format('D/M/YYYY')
}

export const absoluteDatetime = dateString => {
  return moment(dateString).format('l LT')
}

export const dayOfWeek = (dateString, abbreviated) => {
  const format = abbreviated ? 'ddd' : 'dddd'

  return moment(dateString).format(format)
}

export const dayNumber = dateString => {
  return moment(dateString).format('D')
}

export const monthName = (dateString, abbreviated) => {
  const format = abbreviated ? 'MMM' : 'MMMM'

  return moment(dateString).format(format)
}

export const monthNumber = dateString => {
  return moment(dateString).format('M')
}

export const yearNumber = (dateString, abbreviated) => {
  const format = abbreviated ? 'YY' : 'YYYY'

  return moment(dateString).format(format)
}

export const timeOnly = dateString => {
  return moment(dateString).format('LT')
}

export const isoDateTime = dateString => {
  return moment.utc(dateString).format()
}

export const isoDateOnly = dateString => {
  return moment.utc(dateString).format('YYYY-MM-DD')
}

// Generating

export const getDateSourceValue = (source, isAction = false) => {
  // initialize date as local
  let date = moment()

  const options = source.options || {}

  if (options.startOfDay) {
    date = date.startOf('day')
  }

  if (options.offset) {
    if (options.offset % 1 === 0) {
      date.add(options.offset, 'days')
    } else {
      date.add(options.offset * 24 * 60, 'minutes')
    }
  }

  // convert date to UTC
  if (isAction) {
    date = date.utc()
  }

  return serializeDate(date)
}

export const serializeDate = date => {
  return moment(date).format()
}
